import React, { useState, useRef, useEffect, useMemo } from 'react';
import { COUNTRIES } from './countries';

// Single-select searchable country picker, styled to match SectorPicker.
export default function CountryPicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const wrapRef = useRef(null);

  useEffect(() => {
    function onDoc(e) { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); }
    if (open) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const q = query.trim().toLowerCase();
  const shown = useMemo(() => {
    if (!q) return COUNTRIES;
    return COUNTRIES.filter(c => c.label.toLowerCase().includes(q));
  }, [q]);

  function pick(label) {
    onChange(label);
    setOpen(false);
    setQuery('');
  }

  return (
    <div className="secpick" ref={wrapRef}>
      <div className="secpick-field" onClick={() => setOpen(o => !o)}>
        {value
          ? <span className="cpick-val">{value}</span>
          : <span className="secpick-ph">Select country…</span>}
        {value && <button type="button" className="cpick-clear" onClick={(e) => { e.stopPropagation(); onChange(''); }} aria-label="Clear country">×</button>}
        <span className="secpick-caret">{open ? '▴' : '▾'}</span>
      </div>

      {open && (
        <div className="secpick-panel">
          <div className="secpick-search">
            <input
              autoFocus
              value={query}
              onChange={e => setQuery(e.target.value)}
              placeholder="Search countries…"
            />
            {query && <button type="button" className="secpick-clear" onClick={() => setQuery('')}>×</button>}
          </div>
          <div className="secpick-list">
            {shown.length === 0 && <div className="secpick-empty">No matches</div>}
            {shown.map(c => {
              const sel = value === c.label;
              return (
                <button
                  key={c.value}
                  type="button"
                  className={'secpick-opt secpick-opt-item' + (sel ? ' is-sel' : '')}
                  onClick={() => pick(c.label)}
                >
                  <span className="secpick-check">{sel ? '✓' : ''}</span>
                  {c.label}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
